import React from "react";
import { LongTextLabel, TextWithStatus } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
import { UserAvatar } from "Components";
import { AuditLog } from "../../types";
import styles from "./auditLog.module.scss";

const UserInfo = ({ log }: { log: AuditLog }): React.JSX.Element => {
  const user =
    log.user_first_name && log.user_last_name && log.user_email
      ? {
          first_name: log.user_first_name,
          last_name: log.user_last_name,
          email: log.user_email,
        }
      : undefined;

  return (
    <div className={styles["user-info"]}>
      <UserAvatar user={user} size="lg" unknownUserMessage="User unknown" />
      <div className={styles["user-name-auth"]}>
        <TextWithStatus
          text={
            log.user_first_name && log.user_last_name ? (
              <LongTextLabel
                label={`${log.user_first_name} ${log.user_last_name}`}
              />
            ) : (
              "--"
            )
          }
        >
          {log.auth_context &&
            capitalizeFirstLetter(log.auth_context.toLowerCase())}
        </TextWithStatus>
      </div>
    </div>
  );
};

export default UserInfo;
